<div role="dialog" class="relative z-10" aria-labelledby="modal-title" aria-modal="true">
  <div class="fixed inset-0 bg-gray-500/75 transition-opacity" aria-hidden="true"></div>

  <div class="fixed inset-0 z-10 w-screen overflow-y-auto">
    <div class="flex min-h-full items-center justify-center p-4 text-center sm:p-0">
      <div
        class="relative transform overflow-hidden rounded-lg bg-white px-4 pt-5 pb-4 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-sm sm:p-6"
      >
        <div class="pb-3 sm:mx-auto sm:w-full sm:max-w-sm">
          <img alt="Norupe logo" src="assets/logo.svg" class="mx-auto h-10 w-auto" />

          <div class="w-full border-b border-gray-300 pb-10"></div>
        </div>

        <div>
          <div class="mx-auto flex size-9 items-center justify-center rounded-full bg-red-100">
            <mat-icon> no_accounts </mat-icon>
          </div>
          <div class="mt-3 text-center sm:mt-5">
            <h3 class="text-base font-semibold text-gray-900" id="modal-title">Konts nav aktīvs!</h3>
            <div class="mt-2">
              <p class="text-sm text-gray-500">Lai aktivizētu kontu, lūdzu, sazinieties ar Norupes administratoru!</p>
            </div>
          </div>
        </div>
        <div class="mt-5 sm:mt-6">
          <a
            href="/login"
            class="flex w-full justify-center rounded-md bg-green-700 px-3 py-1.5 text-sm/6 font-semibold text-white shadow-xs hover:bg-green-600"
          >
            Uz pieslēgšanās lapu!
          </a>
        </div>
      </div>
    </div>
  </div>
</div>
